const dashboard = {
  dashboardTitle: 'Dashboard',
  policiesTab: 'Policies',
  sadadBillsTab: 'SADAD Bills',
  policyholderName: 'Policyholder Name',
  purchaseDate: 'Purchase Date',
  activationDate: 'Activation Date',
  expirationDate: 'Expiration Date',
  actions: 'Actions',
  printPolicy: 'Print Policy',
  printReceipt: 'Print Receipt',
  benefits: 'Benefits',
  billNumber: 'Bill Number',
  status: 'Status',
  amount: 'Amount',
  dueDate: 'Due Date',
  billerName: 'Biller Name',
  billerCode: 'Biller Code',
  policyAmount: 'Policy Amount',
  billExpiryDate: 'Bill Expiry Date',
  policyholderId: 'Policyholder Id',
  policyHolderFullName: 'Policy Holder Full Name',
  insuranceCompany: 'Insurance Company',
  policyHolderName: 'Policy Holder Name',
  purchasedOn: 'Purchased On',
  policyInceptionDate: 'Policy Effective Date',
  policyExpiryDate: 'Policy Expiry Date',
  policyPurchaseDate: 'Policy Purchase Date',
  policyStatus: 'Policy Status',
  printPolicyAction: 'Print Policy',
  printReceiptAction: 'Print Receipt',
  earnedBenefits: 'Earned Benefits',
  cancelPolicyHeader: 'Submit cancel policy request & refund',
  cancelPolicyButton: 'Submit cancel policy request & refund',
  close: 'Close',
  noBenefitsAvailable: 'No benefits available at the moment',
  showDetails: 'View Details',
  coupon: 'Coupon',
  renewPolicyHeader: 'Policy Renewal',
  renewPolicyButton: 'Renew',
  noBillsFound: 'No bills found',
  cancellationRequestSuccess:
    'Cancel policy request submitted successfully. Expect the insurance company team to contact you within 2–5 business days.',
  myRewardsTab: 'My Rewards',
  currentBalance: 'Current Balance (points)',
  totalAcrossAllTime: 'Total Across all time',
  referredCustomers: 'Referred Customers',
  points: 'Points',
  persons: 'Persons',
  earnings: 'Earnings',
  redeemed: 'Redeemed',
  acrossAllTime: 'Across all time',
  referAndEarn: 'Refer and Earn',
  referralDescription:
    "You'll earn 20 points for every 1 SAR your referred friend spends on Tameeni Medical Malpractice.",
  shareReferralLink: 'Share Referral Link',
  referralLink: 'Referral Link',
  generatingLink: 'Generating Link...',
  email: 'Email: ',
  mobile: 'Mobile: ',
  purchasedPolicies: 'Purchased Policies',
  activeQuotes: 'Active Quotes',
  pendingPolicies: 'Pending Policies',
  myBenefits: 'My Benefits',
  myProfessionInfo: 'My Profession Info',
  active: 'Active',
  pending: 'Pending',
  expired: 'Expired',
  cancelled: 'Cancelled',
  allPolicies: 'All Policies',
  noPoliciesFound: 'No policies found',
  youCanStartBuying: 'You can start buying a new policy',
  buyNow: 'Buy Now',
  purchaseNewPolicy: 'Purchase New Policy',
  noActiveQuotes: 'No active quotes found',
  noActiveQuotesSubtitle: 'You can start buying a new policy',
  noPendingPolicies: 'No pending policies found',
  viewPolicy: 'View Policy',
  paymentReceipt: 'Payment Receipt',
  cancelPolicy: 'Cancel Policy',
  renewPolicy: 'Renew Policy',
  policyIssuanceInProgress: 'Policy issuance is in-progress',
  policyPrice: 'Policy Price',
  policyNumber: 'Policy Number',
  policyHolderId: 'Policy Holder ID',
  noBenefitsEarned: 'No benefits earned yet',
  professionInfoHint:
    'Upon renewal with Tameeni you will be able to update your profession info',
  qualification: 'Qualification',
  performingSurgeries: 'Performing Surgeries',
  experience: 'Experience',
  specialty: 'Specialty',
  placeOfPractice: 'Place of Practice',
  noSadadBills: 'Currently no SADAD bills',
  noProfessionInfo: 'No profession info available',
  quoteTimeOut: 'Quote Time Out',
  viewQuote: 'View Quote',
  failedToLoadQuotes: 'Failed to load quotes',
  tryAgain: 'Try Again',
  subSpecialty: 'Sub-Specialty',
  failedToLoadProfession: 'Failed to load profession info',
  failedToLoadBenefits: 'Failed to load benefits',
} as const

export default dashboard
